export default __webpack_public_path__ + "assets/assignment-30d6ca2.svg";